var storefrontApp = angular.module('storefrontApp');

storefrontApp.component('vcLineItems', {
    templateUrl: "themes/assets/js/common-components/lineItems.tpl.liquid",
    bindings: {
        items: '=',
        orderType: '<',
        editMode: '<',
        providers: '<',
        onIncreaseQuantityMethod: '&',
        onDecreaseQuantityMethod: '&',
        onRemoveItemMethod: '&',
        form: '<',
        isImpersonating: '<'
    },
    controller: [function () {
        var $ctrl = this;

        $ctrl.decreaseQuantity = decreaseQuantity;
        $ctrl.increaseQuantity = increaseQuantity;
        $ctrl.removeItem = removeItem;
        $ctrl.lineItemProviderChanged = lineItemProviderChanged;

        function decreaseQuantity(lineItem) {
            $ctrl.onDecreaseQuantityMethod({ lineItem: lineItem });
        }

        function increaseQuantity(lineItem) {
            $ctrl.onIncreaseQuantityMethod({ lineItem: lineItem });
        }

        function removeItem(lineItem) {
            $ctrl.onRemoveItemMethod({ lineItem: lineItem });
        }

        function lineItemProviderChanged(lineItem) {
            if (lineItem.providerId) {
                lineItem.providerName = _.find($ctrl.providers, function (p) { return p.id == lineItem.providerId; }).fullName;
            }
            else {
                lineItem.providerName = null;
            }
        }

    }]
});
